import PropTypes from 'prop-types';
var sizes = ['xs', 'sm', 'md', 'lg', 'xl'];
export default PropTypes.oneOf(sizes);